import type Item from 'owa-service/lib/contract/Item';
import type Message from 'owa-service/lib/contract/Message';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

export function partialUpdateItem(itemToUpdate: Item, item: Item, tableView: TableView) {
    if (tableView.tableQuery.type !== 1) {
        // Skip updating the ItemId for search table, as the ItemId.ChangeKey in executeSearch results are different
        itemToUpdate.ItemId = item.ItemId;

        // Skip updating ReceivedOrRenewTime as it's not returned
        itemToUpdate.ReceivedOrRenewTime = item.ReceivedOrRenewTime;
    }

    // Common partial update
    itemToUpdate.Subject = item.Subject;
    itemToUpdate.Importance = item.Importance;
    itemToUpdate.Sensitivity = item.Sensitivity;
    itemToUpdate.HasAttachments = item.HasAttachments;
    itemToUpdate.ItemClass = item.ItemClass;
    itemToUpdate.Flag = item.Flag;
    itemToUpdate.Categories = item.Categories;
    itemToUpdate.SystemCategories = item.SystemCategories;
    itemToUpdate.PredictedActionReasons = item.PredictedActionReasons;

    // Mail folder specific updates
    itemToUpdate.ParentFolderId = item.ParentFolderId;
    itemToUpdate.ConversationId = item.ConversationId;
    itemToUpdate.DateTimeReceived = item.DateTimeReceived;
    itemToUpdate.IsDraft = item.IsDraft;
    itemToUpdate.Size = item.Size;
    itemToUpdate.IsClutter = item.IsClutter;
    itemToUpdate.Preview = item.Preview;
    itemToUpdate.DisplayTo = item.DisplayTo;
    itemToUpdate.IconIndex = item.IconIndex;

    // Only update return time if item provides value
    if (!!item.ReturnTime) {
        itemToUpdate.ReturnTime = item.ReturnTime;
    }

    // Message specific updates
    if (
        itemToUpdate.ItemClass.indexOf('IPM.Schedule.Meeting') !== -1 ||
        itemToUpdate.ItemClass.indexOf('IPM.Note') !== -1
    ) {
        const messageToUpdate = itemToUpdate as Message;
        const message = item as Message;

        messageToUpdate.IsRead = message.IsRead;

        if (tableView.tableQuery.type !== 1) {
            // Skip updating the following properties in search as they're not returned
            messageToUpdate.IsReadReceiptRequested = message.IsReadReceiptRequested;
            messageToUpdate.IsDeliveryReceiptRequested = message.IsDeliveryReceiptRequested;
        }
    }
}
